import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionDialog } from '../../models/message-dialog/enum';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: true,
    imports: [MatButton],
})
export class MessageDialogComponent {
    @Input()
    messageBoxText: string;

    @Output()
    onClickDialog = new EventEmitter<ActionDialog>();

    constructor() {}

    public _onClickDialog(ops) {
        this.onClickDialog.emit(ops);
    }
}
